import { useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

const LOGO = "/brand/mtg_logo.svg";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from || "/app";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  async function onSubmit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Bienvenue dans MonTempsGagné");
      navigate(from, { replace: true });
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Identifiants incorrects");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen kf-mesh flex items-center justify-center px-6 py-10">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-8">
          <img src={LOGO} className="h-11" alt="MonTempsGagné" />
        </div>
        <div className="kf-card p-8">
          <h1 className="font-display text-2xl font-bold text-[#16324F]">Espace professionnel</h1>
          <p className="text-sm text-slate-500 mt-1">Connectez-vous pour gérer vos devis et réservations.</p>
          {from !== "/app" && (
            <p className="mt-3 text-xs text-[#19C3B3] font-semibold" data-testid="login-redirect-hint">Vous serez redirigé vers la page demandée après connexion.</p>
          )}
          <form onSubmit={onSubmit} className="mt-6 grid gap-4">
            <div className="grid gap-1.5">
              <Label htmlFor="email">Adresse e-mail</Label>
              <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="vous@entreprise.fr" data-testid="login-email" />
            </div>
            <div className="grid gap-1.5">
              <Label htmlFor="password">Mot de passe</Label>
              <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" data-testid="login-password" />
            </div>
            <Button type="submit" disabled={loading} className="rounded-full bg-[#16324F] hover:bg-[#0F2438] h-11 text-base font-semibold" data-testid="login-submit">
              {loading ? "Connexion…" : "Se connecter"}
            </Button>
          </form>
        </div>
        <div className="mt-6 text-center">
          <Link to="/" className="text-sm font-semibold text-slate-500 hover:text-[#16324F] transition-base" data-testid="login-back-home">← Retour à l'accueil</Link>
        </div>
      </div>
    </div>
  );
}
